let app = angular.module('clickbooth-common')

.factory('modalCreativePreview', function ($modal, $rootScope, config, MMRCases, $sce) {
    let scope = $rootScope.$new(true);
    scope.config = config;
    scope.service = MMRCases;

    scope.getMMRCreativeImage = function(creative, preview = null){
        // Handle MMR case details modal structure
        if (creative.file && creative.file.url) {
            // If file.url is already set (from MMR case details modal), use it
            return creative.file.url;
        }
        
        // Handle temp vs permanent files
        if(creative.file && creative.file.id == 0){
            return scope.service.getTempMMRCreativeImage(creative, preview);
        }

        return scope.service.getMMRCreativeImage(creative, preview);
    }

    scope.getMMRCreativeThumbnail = function(creative){
        // Handle temp vs permanent files
        if(creative.file && creative.file.id == 0){
            return scope.service.getTempMMRCreativeThumbnail(creative);
        }

        // For permanent files, we don't have thumbnail generation yet
        // Return empty string to use browser's default video poster
        return '';
    }

    scope.trustSrc = function(url) {
        return $sce.trustAsResourceUrl(url);
    }

    let modal = $modal({
        scope: scope,
        templateUrl: template('creative-preview-modal/creative-preview'),
        show: false
    });

    return {
        show(creative, index) {
            scope.creative = creative;
            modal.$promise.then(modal.show);
            scope.index = index;
        }
    }
});
